export const sessionIsLoadingSelector = state => state.login.sessionIsLoading
export const userIsLoggedInSelector   = state => state.login.userIsLoggedIn